import * as Models from 'contracts/models';

export const Endpoint = () => `/api/v3/agent/list/`;
export const QueryKey = (payload: Payload | undefined) => ['v3', 'agent', 'list', payload].filter(Boolean);
export type Payload = { size: number };
export type Response = {
    agentIds: Models.Agents.Agent[];
    totalCount: number;
};
